<template>
  <div class="screen">
    <i
      class="sz "
      :class="isFullscreen?'szln_quanpingtuichu':'szquanping'"
      @click="click"
    ></i>
  </div>
</template>

<script>
import screenfull from "screenfull";

export default {
  name: "Screenfull",
  data() {
    return {
      isFullscreen: false,
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    click() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: "抱歉,您的浏览器不支持！",
          type: "warning",
        });
        return false;
      }
      screenfull.toggle();
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen;
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on("change", this.change);
      }
    },
    destroy() {
      if (screenfull.isEnabled) {
        screenfull.off("change", this.change);
      }
    },
  },
};
</script>

<style scoped>
.screen {
  float: left;
  width: 50px;
  height: 60px;
  line-height: 60px;
}
i {
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;
}
</style>
